'use strict';

angular.module('completeAir.version.version-directive', [])

    .directive("breadCrumbs", ['$timeout', function($timeout){
        return {
            templateUrl: 'app/pages/bread-crumbs.html',
            link: function(scope, element, attrs){
                $timeout(function(){
                    $("#faBreadcrumb").addClass(attrs.fa);
                    $("#nameBreadcrumb").html(attrs.menu);
                    $("#sectionBreadcrumb").html(attrs.option);
                }, 10);
            }
        }
    }])
    .directive('pageHeader', ['version',  function(){
        return {
            templateUrl: 'app/pages/header.html'
        }
    }])
    .directive('multiSelect', ['$q', function($q){
        function link(scope, element, attrs){

            setTimeout(function(){
                $(element).multiSelect();
            },500)
        }

        return {
            link: link
        }
    }])
